import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert, Button } from 'react-bootstrap';
import { useGetUnseenOrdersCountQuery } from '../slices/ordersApiSlice';
import { useSelector } from 'react-redux';

const AdminOrderNotifier = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const isAdmin = !!userInfo?.isAdmin;

  const location = useLocation();
  const navigate = useNavigate();
  const prevCountRef = useRef(0);
  const [show, setShow] = useState(false);

  // Poll every 30 seconds
  const { data } = useGetUnseenOrdersCountQuery(undefined, {
    pollingInterval: 30000,
    skip: !isAdmin,
  });

  const count = data?.count || 0;

  useEffect(() => {
    if (!isAdmin) return;

    const prev = prevCountRef.current;
    prevCountRef.current = count;

    // If count increased and we are NOT on the order list screen
    const onOrderList = location.pathname.startsWith('/admin/orderlist');

    if (!onOrderList && count > prev) {
      setShow(true);

      // play sound
      try {
        const audio = new Audio('/sounds/new-order.mp3');
        audio.play().catch(() => {});
      } catch (_) {}
    }

    // if count goes to 0, hide popup
    if (count === 0) {
      setShow(false);
    }
  }, [count, isAdmin, location.pathname]);

  if (!isAdmin || !show || count <= 0) return null;

  return (
    <div
      style={{
        position: 'fixed',
        right: '1rem',
        bottom: '1rem',
        zIndex: 1050,
        maxWidth: '320px',
      }}
    >
      <Alert variant="warning" className="mb-2">
        <Alert.Heading className="h6 mb-2">
          New order{count > 1 ? 's' : ''} received
        </Alert.Heading>
        <p className="mb-2">
          You have <strong>{count}</strong> order
          {count > 1 ? 's' : ''} not seen yet.
        </p>
        <div className="d-flex justify-content-end">
          <Button
            size="sm"
            variant="primary"
            onClick={async () => {
              setShow(false);
              navigate('/admin/orderlist');
            }}
          >
            View orders
          </Button>
        </div>
      </Alert>
    </div>
  );
};

export default AdminOrderNotifier;
